import React from "react";

function Activities() {
  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold">Activities Page</h1>
      <p>Details about activities...</p>
    </div>
  );
}

export default Activities;